const state = () => ({
  token: null,
  refreshTokenRequest: null
});

const getters = {
  token(state) {
    return state.token;
  },
  refreshTokenRequest(state) {
    return state.refreshTokenRequest;
  }
};

const mutations = {
  setToken(state, payload) {
    state.token = payload.token;
  },
  setRefreshTokenRequest(state, payload) {
    state.refreshTokenRequest = payload;
  }
};

const actions = {
  setToken({ commit }, payload) {
    commit('setToken', payload);
  }
};

export const apiToken = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
